import { useTranslation } from "react-i18next";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import type { CalendarEvent } from "@/components/calendar/views/CalendarEventTypes";
import type { AppointmentStatus } from "@/hooks/useAppointmentStatuses";
import { MobileEventCard } from "./MobileEventCard";

type Props = {
  date: Date;
  events: CalendarEvent[];
  statuses: AppointmentStatus[];
  onAppointmentClick: (id: string) => void;
};

export function MobileDayEventList({ date, events, statuses, onAppointmentClick }: Props) {
  const { t } = useTranslation("calendar");
  const title = format(date, "EEEE, d 'de' MMMM", { locale: ptBR });
  const countLabel = t("mobile.appointmentCount", { count: events.length });
  const statusLabelOf = (name: string) =>
    statuses.find((s) => s.name === name)?.display_name ?? name;

  return (
    <div>
      <div className="mb-2.5 flex items-center justify-between">
        <span className="text-[15px] font-bold capitalize text-foreground">{title}</span>
        <span className="rounded-full border border-border bg-card px-2.5 py-1 text-[11px] font-semibold text-muted-foreground">
          {countLabel}
        </span>
      </div>
      {events.length === 0 ? (
        <div className="rounded-2xl border border-border/60 bg-card px-4 py-7 text-center text-sm text-muted-foreground">
          {t("mobile.emptyDay")}
        </div>
      ) : (
        <div className="flex flex-col gap-2.5">
          {events.map((event) => (
            <MobileEventCard
              key={event.id}
              event={event}
              statuses={statuses}
              statusLabel={statusLabelOf(event.status)}
              onClick={onAppointmentClick}
            />
          ))}
        </div>
      )}
    </div>
  );
}
